import React from 'react'
import './Style.scss'

const BaseButton = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = 'btn btn-primary',
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      {...props}
    >
      {children}
    </button>
  )
}

export default BaseButton
